import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import generateUUID from 'syf-js-utilities/helpers/generateUUID';
import { colors } from '../../../defaultTheme';
export const defaultWidth = 200;
export const getMeterConsts = ({ width, height, isSegmentedMeter, textYManual, textDyManual, labelPtManual, valuePtManual }) => {
    const radius = width * (3 / 7);
    const sizeMultiplier = width / defaultWidth;
    const gradientId = `meterGradient-${generateUUID()}`;
    const textYDefault = height / 1.35;
    const textDyDefault = 25 * sizeMultiplier;
    const labelPtDefault = (isSegmentedMeter ? 12 : 14) * sizeMultiplier;
    const valuePtDefault = 18 * sizeMultiplier;
    return {
        radius,
        strokeWidth: radius * (1 / 3),
        center: radius * (7 / 6),
        textY: textYManual !== null && textYManual !== void 0 ? textYManual : textYDefault,
        textDy: textDyManual !== null && textDyManual !== void 0 ? textDyManual : textDyDefault,
        labelPt: labelPtManual !== null && labelPtManual !== void 0 ? labelPtManual : labelPtDefault,
        valuePt: valuePtManual !== null && valuePtManual !== void 0 ? valuePtManual : valuePtDefault,
        gradientId,
        gradientColor: `url(#${gradientId})`,
        unfilledColor: colors.lightGrey
    };
};
export const LinearGradient = ({ id }) => {
    const consumerTheme = useTheme();
    const { gradientStart, gradientEnd } = (consumerTheme === null || consumerTheme === void 0 ? void 0 : consumerTheme.meter) || {};
    return (_jsxs("linearGradient", Object.assign({ id: id, gradientUnits: "userSpaceOnUse" }, { children: [_jsx("stop", { stopColor: gradientStart, offset: "0" }), _jsx("stop", { stopColor: gradientEnd, offset: "1" })] })));
};
